module.exports = __webpack_public_path__ + "images/c33113aa58fa64b54902f4210f1f5d4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/diaryofanant-story00.jpg
// module id = ./webpack/assets/img/diaryofanant-story00.jpg
// module chunks = 0